import { useDispatch } from 'react-redux';

import PaymentMethod, { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { addNewPayMethods } from '~/src/features/payments-abn/store/actions';

const sberpayMethod: IMethodData = {
    id: 'sberpay',
    methodType: 'sberpay',
    label: 'SberPay',
    value: 'sberpay',
    imagePath: '/static/images/payments-abn/pay-systems/sberpay.png',
    imageAlt: 'Логотип Сбера',
    isAutoPayConnected: true,
};

/**
 * Добавляет таб СберПэй к доступным методам оплаты
 */
export const useSberPayTab = (): void => {
    const dispatch = useDispatch();

    sberpayMethod.widget = PaymentMethod;

    dispatch(addNewPayMethods([sberpayMethod]));
};
